(function () {
  if (customElements.get('similar-style-slider')) return;

  class SimilarStyleSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.similar-style__slider');
      if (!this.slider) return;

      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => {
        this.destroySlider();
        this.createSlider();
      });

      if (typeof Flickity !== 'undefined') {
        this.createSlider();
      } else {
        window.addEventListener('load', () => this.createSlider(), { once: true });
      }
    }

    createSlider() {
      if (typeof Flickity === 'undefined') return;
      const opts = window.getFlickityOptions(this);
      this.flkty = new Flickity(this.slider, opts);

      if (typeof window.datoraUpdatePrices === 'function') {
        Promise.resolve(window.datoraUpdatePrices(this)).finally(() => {
          requestAnimationFrame(() => this.flkty?.resize());
        });
      }
    }

    destroySlider() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    disconnectedCallback() {
      this.cleanupBreakpoint?.();
      this.destroySlider();
    }
  }

  customElements.define('similar-style-slider', SimilarStyleSlider);
})();
